import React, { useEffect } from "react";
import { FaMailBulk, FaPhoneAlt } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Banner from "../../assets/img/about-us.png";
import CustomBanner from "../../components/CustomBanner";
import { Helmet } from "react-helmet";
import axiosClient from "../../api";
import { toast } from "react-toastify";
import { Link, useLocation } from "react-router-dom";

const ContactPage = () => {
  const [categories, setCategories] = React.useState([]);
  const [checkbox, setCheckbox] = React.useState(false);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    axiosClient.get("/Category/GetAllCategoryHierarchy").then((res) => {
      setCategories(res.data.categories);
    });
  }, []);

  const validationSchema = Yup.object({
    FirstName: Yup.string().required("Lütfen isminizi giriniz"),
    lastName: Yup.string().required("Soyisim gereklidir"),
    email: Yup.string()
      .email("Geçerli bir email giriniz")
      .required("Lütfen email adresinizi giriniz"),
    PhoneNumber: Yup.string().required("Lütfen telefon numaranızı giriniz"),
    productId: Yup.string().required("Ürün gereklidir"),
    message: Yup.string().required("Mesaj gereklidir"),
  });
  const location = useLocation();
  const somePropValue = location?.state?.name;
  const productId = location?.state?.productId;

  const initialValues = {
    FirstName: "",
    lastName: "",
    email: "",
    PhoneNumber: "",
    productId: productId ? productId : "",
    message: somePropValue
      ? `${somePropValue} hakkında bilgi almak istiyorum.`
      : "",
  };

  console.log(productId);

  const onSubmit = (values, { setSubmitting, resetForm }) => {
    // Handle form sbmission logic here
    axiosClient
      .post("/Contact", values)
      .then((res) => {
        toast.success("Mesajınız başarıyla gönderildi.");
        resetForm();
      })
      .catch((error) => {
        toast.error("Mesaj gönderilemedi. Lütfen tekrar deneyin.");
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <div className="">
      <Helmet>
        <title>İletişim - LENSA</title>
        <meta
          name="description"
          content="İletişim sayfamızdan bizimle iletişime geçebilirsiniz."
        />
      </Helmet>
      <CustomBanner title="İletişim" breadTitle="İletişim" image={Banner} />
      <div className="container py-20">
        <div className="flex gap-10 max-md:flex-col">
          <div className="flex-[3_3_0] bg-white rounded-sm">
            <div className="p-5 border">
              <h2 className="text-3xl font-semibold text-main">
                İletişime Geç
              </h2>
              <div className="text-main">
                <p className="font-semibold text-xl mt-5">İstanbul</p>
                <div className="flex items-center mt-3 gap-2">
                  <FaLocationDot className="flex-1" size={25} />
                  <p className="flex-[11_11_0] font-semibold">
                    İstanbul Ofis: Kaptanpaşa Mah. Halit Ziya Türkkan Sok. Famas
                    Plaza C Blok No: 19 Şişli / İstanbul
                  </p>
                </div>
                <div className="flex items-center mt-3 gap-2 text-main">
                  <FaPhoneAlt className="flex-1" size={25} />
                  <p className="flex-[11_11_0] font-semibold">
                    <a href="tel:+908507377564" className="font-semibold">
                      +90 850 737 7564
                    </a>
                  </p>
                </div>
                <div className="flex items-center mt-3 gap-2 text-main">
                  <FaMailBulk className="flex-1" size={25} />
                  <p className="flex-[11_11_0] font-semibold">
                    <a href="mailto:info@lensa.com.tr">info@lensa.com.tr</a>
                  </p>
                </div>
              </div>
              <div className="text-main">
                <p className="font-semibold text-xl mt-5">Ankara</p>
                <div className="flex items-center mt-3 gap-2">
                  <FaLocationDot className="flex-1" size={25} />
                  <p className="flex-[11_11_0] font-semibold">
                    Ehlibeyt Mahallesi Tekstilciler Caddesi. Bayraktar Plaza
                    No:17A D:29 Çankaya / Ankara
                  </p>
                </div>
                <div className="flex items-center mt-3 gap-2 text-main">
                  <FaPhoneAlt className="flex-1" size={25} />
                  <p className="flex-[11_11_0] font-semibold">
                    <a href="tel:+908507377564" className="font-semibold">
                      +90 850 737 7564
                    </a>
                  </p>
                </div>
                <div className="flex items-center mt-3 gap-2 text-main">
                  <FaMailBulk className="flex-1" size={25} />
                  <p className="flex-[11_11_0] font-semibold">
                    <a href="mailto:info@lensa.com.tr">info@lensa.com.tr</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-[7_7_0]">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({ isSubmitting }) => (
                <Form className="flex flex-col justify-between h-full">
                  <div>
                    <p className="font-semibold text-3xl text-main">
                      İletişime Geç
                    </p>
                  </div>
                  <div className="flex gap-5 mt-5 max-md:flex-col">
                    <div className="flex-1 flex flex-col">
                      <label
                        className="font-semibold text-xl text-main"
                        htmlFor="FirstName"
                      >
                        İsim*
                      </label>
                      <Field
                        className="border-b bg-transparent border-b-main focus:outline-none py-1 text-md text-main"
                        type="text"
                        id="FirstName"
                        name="FirstName"
                      />
                      <ErrorMessage
                        className="text-red-500"
                        name="FirstName"
                        component="div"
                      />
                    </div>
                    <div className="flex-1">
                      <div className="flex flex-col">
                        <label
                          className="font-semibold text-xl text-main"
                          htmlFor="lastName"
                        >
                          Soyisim*
                        </label>
                        <Field
                          className="border-b bg-transparent border-b-main focus:outline-none py-1 text-md text-main"
                          type="text"
                          id="lastName"
                          name="lastName"
                        />
                        <ErrorMessage
                          className="text-red-500"
                          name="lastName"
                          component="div"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-5 max-md:flex-col">
                    <div className="flex flex-col mt-5 flex-1">
                      <label
                        className="font-semibold text-xl text-main"
                        htmlFor="email"
                      >
                        Email*
                      </label>
                      <Field
                        className="border-b bg-transparent border-b-main focus:outline-none py-1 text-md text-main"
                        type="email"
                        id="email"
                        name="email"
                      />
                      <ErrorMessage
                        className="text-red-500"
                        name="email"
                        component="div"
                      />
                    </div>
                    <div className="flex flex-col mt-5 flex-1">
                      <label
                        className="font-semibold text-xl text-main"
                        htmlFor="PhoneNumber"
                      >
                        Telefon*
                      </label>
                      <Field
                        className="border-b bg-transparent border-b-main focus:outline-none py-1 text-md text-main"
                        type="text"
                        id="PhoneNumber"
                        name="PhoneNumber"
                      />
                      <ErrorMessage
                        className="text-red-500"
                        name="PhoneNumber"
                        component="div"
                      />
                    </div>
                  </div>
                  <div className="flex flex-col h-max gap-5 mt-5 flex-1">
                    <label
                      className="font-semibold text-md text-main"
                      htmlFor="productId"
                    >
                      Talep Edilen Ürün*
                    </label>
                    <Field
                      className="border-b bg-transparent border-b-main focus:outline-none text-md text-main"
                      as="select"
                      id="productId"
                      name="productId"
                    >
                      <option value={productId ? productId : ""}>
                        {somePropValue ? somePropValue : "Ürün Seçiniz"}
                      </option>
                      {categories?.map((category) => (
                        <optgroup label={category.name}>
                          {category.product.map((product) => (
                            <option value={product.id}>{product.name}</option>
                          ))}
                          {category.subCategories.map((subCategory) =>
                            subCategory.product.map((product) => (
                              <option value={product.id}>{product.name}</option>
                            ))
                          )}
                        </optgroup>
                      ))}
                    </Field>
                    <ErrorMessage
                      className="text-red-500"
                      name="productId"
                      component="div"
                    />
                  </div>
                  <div className="flex flex-col mt-5">
                    <label
                      className="font-semibold text-xl text-main"
                      htmlFor="message"
                    >
                      Mesaj*
                    </label>
                    <Field
                      className="bg-transparent border border-main focus:outline-none py-1 px-2 text-md text-main"
                      as="textarea"
                      id="message"
                      name="message"
                      rows="3"
                    />
                    <ErrorMessage
                      className="text-red-500"
                      name="message"
                      component="div"
                    />
                  </div>
                  <div className="flex gap-5 mt-2 max-md:flex-col items-center">
                    <label htmlFor="newsletter">
                      <input
                        type="checkbox"
                        id="newsletter"
                        name="newsletter"
                        className="mr-1 !text-lg"
                        checked={checkbox}
                        onChange={(e) => setCheckbox(e.target.checked)}
                        value={checkbox}
                      />
                      <span className="text-sm text-main">
                        Form gönderme koşullarını ve kişisel verilerin
                        kullanılması ve korunması hakkındaki aydınlatma metnini
                        okudum, onaylıyorum.
                      </span>
                      <p className="text-sm text-main mt-3">
                        Yukarıdaki alanlar üzerinden tarafımıza açıklayacağınız
                        kişisel verileriniz LENSA Sanayi ve Ticaret Anonim
                        Şirketi tarafından İletişim Faaliyetlerinin Yürütülmesi,
                        Talep / Şikayetlerin Takibi, İş Süreçlerinin
                        İyileştirilmesine Yönelik Önerilerin Alınması Ve
                        Değerlendirilmesi, Mal / Hizmet Satış Sonrası Destek
                        Hizmetlerinin Yürütülmesi, Müşteri Memnuniyetine Yönelik
                        Aktivitelerin Yürütülmesi, Müşteri İlişkileri Yönetimi
                        Süreçlerinin Yürütülmesi amaçlarıyla işlenecektir.
                        Ayrıntılı bilgiye{" "}
                        <Link
                          className="font-bold"
                          to="/iletisim-formu-aydinlatma-metni"
                        >
                          İletişim Formu Aydınlatma Metni
                        </Link>
                        ’nden ulaşabilirsiniz.”
                      </p>
                    </label>
                  </div>
                  <button
                    type="submit"
                    className="mt-5 bg-main py-2 text-white"
                    disabled={!checkbox}
                  >
                    Gönder
                  </button>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
